var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch"},[_c('span',{class:[
      'switch-label switch-label--off',
      _vm.switchEnabled == 0 ? 'switch-label--enabled' : '',
      _vm.options[0].title.length > 10 ? 'switch-label--small' : ''
    ],domProps:{"innerHTML":_vm._s(_vm.options[0].title)},on:{"click":function($event){return _vm.switchOption(0)}}}),_c('span',{class:[
      'switch-label switch-label--on',
      _vm.switchEnabled == 1 ? 'switch-label--enabled' : '',
      _vm.options[1].title.length > 10 ? 'switch-label--small' : ''
    ],domProps:{"innerHTML":_vm._s(_vm.options[1].title)},on:{"click":function($event){return _vm.switchOption(1)}}}),_c('switches',{attrs:{"theme":"custom","color":"blue"},on:{"input":_vm.onChange},model:{value:(_vm.switchEnabled),callback:function ($$v) {_vm.switchEnabled=$$v},expression:"switchEnabled"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }